export class CustomResponse<T> {
  constructor(public payload: T, public message: string = '', public status: Status = Status.OK) {}
}

export enum Status {
  OK = 'OK',
  KO = 'KO',
}
